import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { Instagram, Mail } from "lucide-react";

export const Footer = () => {
  const { t } = useLang();

  const wanderLinks = [
    { type: "hash", target: "story" },
    { type: "hash", target: "table" },
    { type: "hash", target: "tiers" },
    { type: "hash", target: "boarding" },
    { type: "route", target: "/support" },
  ];

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#2c1e16] text-[#f9f6f0] pt-20 md:pt-28 pb-10 border-t border-[#3a2820]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-12 mb-16">
          <div className="col-span-12 md:col-span-6">
            <h3 className="font-serif-display text-5xl md:text-7xl leading-[0.95] tracking-tight text-[#f9f6f0]">
              Afro-Swiss<br />
              <em className="text-[#a64b2a] not-italic">·</em> Soul Food
            </h3>
            <p className="mt-6 font-serif-display italic text-xl md:text-2xl text-[#f9f6f0]/70 max-w-md">
              {t.footer.tagline}
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono-utility text-[10px] tracking-[0.3em] uppercase text-[#a64b2a] mb-5">
              {t.footer.contact}
            </div>
            <div className="space-y-2 text-sm text-[#f9f6f0]/80">
              <div className="font-mono-utility text-[10px] tracking-[0.25em] uppercase text-[#f9f6f0]/50">
                {t.footer.email_label}
              </div>
              <a
                href="mailto:hello@afro-swiss-soulfood.ch"
                data-testid="footer-email"
                className="link-underline"
              >
                hello@afro-swiss-soulfood.ch
              </a>
              <p className="pt-3 text-[#f9f6f0]/70">{t.footer.city}</p>
            </div>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono-utility text-[10px] tracking-[0.3em] uppercase text-[#a64b2a] mb-5">
              {t.footer.links_title}
            </div>
            <ul className="space-y-2 text-sm text-[#f9f6f0]/80">
              {wanderLinks.map((link, i) => (
                <li key={i}>
                  {link.type === "route" ? (
                    <Link
                      to={link.target}
                      data-testid={`footer-link-${link.target.replace("/", "")}`}
                      className="link-underline"
                    >
                      {t.footer.links[i]}
                    </Link>
                  ) : (
                    <a
                      href={`/#${link.target}`}
                      data-testid={`footer-link-${link.target}`}
                      className="link-underline"
                    >
                      {t.footer.links[i]}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#3a2820] flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="font-mono-utility text-[10px] tracking-[0.25em] uppercase text-[#f9f6f0]/50">
            {t.footer.legal}
          </div>
          <div className="flex items-center gap-5">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              data-testid="social-instagram"
              className="text-[#f9f6f0]/70 hover:text-[#a64b2a] transition-colors"
            >
              <Instagram className="w-4 h-4" strokeWidth={1.5} />
            </a>
            <a
              href="mailto:hello@afro-swiss-soulfood.ch"
              aria-label="Email"
              data-testid="social-email"
              className="text-[#f9f6f0]/70 hover:text-[#a64b2a] transition-colors"
            >
              <Mail className="w-4 h-4" strokeWidth={1.5} />
            </a>
            <span className="font-mono-utility text-[10px] tracking-[0.25em] uppercase text-[#f9f6f0]/50">
              {t.footer.built}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
